import fetchApi from "../fetchApi";
export const getReceipt = async (
    {id, type = "regular"}
   ) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/${id}/${type}/receipt`, options);
};